module.exports = __webpack_public_path__ + "img/maobi46.281b6002.png";